var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardTimeout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9391_117759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8H3V10H10V8Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H3V13H8V11Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7H17.999V8H20V2C20 0.896 19.104 0 18 0H2C0.897 0 0 0.896 0 2V14C0 15.103 0.897 16 2 16H8V14H2V7ZM18 2L17.999 5H2V2H18Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10C13.141 10 10 13.14 10 17C10 20.861 13.141 24 17 24C20.86 24 24 20.861 24 17C24 13.14 20.86 10 17 10ZM17 22C14.243 22 12 19.757 12 17C12 14.243 14.243 12 17 12C19.757 12 22 14.243 22 17C22 19.757 19.757 22 17 22Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13H16V18H20V16H18V13Z",
    fill: "#555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9391_117759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardTimeout);
export default __webpack_public_path__ + "static/media/credit-card-timeout.dc5f9e70887bad80b06a2da3830bc014.svg";
export { ForwardRef as ReactComponent };